var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container leader-hunter-page" },
    [
      _c("div", { staticClass: "page-heading" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "heading-actions" },
          [
            _vm.canManageSettings
              ? _c(
                  "el-button",
                  {
                    attrs: {
                      "data-testid": "tour-leader-settings-entry",
                      icon: "el-icon-setting",
                    },
                    on: { click: _vm.openSettings },
                  },
                  [_vm._v(" 專區設定 ")]
                )
              : _vm._e(),
            _vm.canUseAgencyCommunication && !_vm.featureDisabled
              ? _c(
                  "el-button",
                  {
                    attrs: {
                      "data-testid": "agency-communication-history",
                      icon: "el-icon-time",
                    },
                    on: { click: _vm.openHistory },
                  },
                  [_vm._v(" 邀約與聊天歷史 ")]
                )
              : _vm._e(),
            _c(
              "el-tooltip",
              { attrs: { content: "徵才啟事", placement: "left" } },
              [
                _c("el-button", {
                  staticClass: "jobs-entry",
                  attrs: {
                    type: "warning",
                    icon: "el-icon-suitcase",
                    circle: "",
                    "aria-label": "徵才啟事",
                    disabled: _vm.featureDisabled,
                  },
                  on: { click: _vm.openJobs },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm.featureDisabled
        ? _c(
            "el-alert",
            {
              staticClass: "load-alert",
              attrs: {
                "data-testid": "tour-leader-feature-disabled",
                type: "warning",
                title: "此旅行社的領隊導遊專區目前已關閉。",
                description:
                  "搜尋、徵才、邀約與聊天已停用；如需開放，請聯絡系統管理員。",
                closable: false,
                "show-icon": "",
              },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { slot: "default", size: "mini" },
                  on: { click: _vm.fetchProfiles },
                  slot: "default",
                },
                [_vm._v("重新檢查")]
              ),
            ],
            1
          )
        : _vm._e(),
      !_vm.featureDisabled
        ? _c(
            "el-card",
            { staticClass: "filter-card", attrs: { shadow: "never" } },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: true, model: _vm.query },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "關鍵字" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "50",
                          clearable: "",
                          placeholder: "姓名或暱稱",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.search($event)
                          },
                        },
                        model: {
                          value: _vm.query.keyword,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.query,
                              "keyword",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "query.keyword",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "身分" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "全部" },
                          model: {
                            value: _vm.query.role,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "role", $$v)
                            },
                            expression: "query.role",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "領隊", value: "leader" },
                          }),
                          _c("el-option", {
                            attrs: { label: "導遊", value: "guide" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "性別" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            "collapse-tags": "",
                            clearable: "",
                            placeholder: "全部",
                          },
                          model: {
                            value: _vm.query.genders,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "genders", $$v)
                            },
                            expression: "query.genders",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "男", value: "male" },
                          }),
                          _c("el-option", {
                            attrs: { label: "女", value: "female" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "年齡區間" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            "collapse-tags": "",
                            clearable: "",
                            placeholder: "全部",
                          },
                          model: {
                            value: _vm.query.ageRanges,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "ageRanges", $$v)
                            },
                            expression: "query.ageRanges",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "30 歲以下", value: "under30" },
                          }),
                          _c("el-option", {
                            attrs: { label: "30–39 歲", value: "30-39" },
                          }),
                          _c("el-option", {
                            attrs: { label: "40–49 歲", value: "40-49" },
                          }),
                          _c("el-option", {
                            attrs: { label: "50–59 歲", value: "50-59" },
                          }),
                          _c("el-option", {
                            attrs: { label: "60 歲以上", value: "60plus" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "帶團區域" } },
                    [
                      _c("el-select", {
                        attrs: {
                          multiple: "",
                          filterable: "",
                          "allow-create": "",
                          "default-first-option": "",
                          "collapse-tags": "",
                          clearable: "",
                          placeholder: "請輸入區域",
                        },
                        model: {
                          value: _vm.query.guidanceAreas,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "guidanceAreas", $$v)
                          },
                          expression: "query.guidanceAreas",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "帶團年資" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            "collapse-tags": "",
                            clearable: "",
                            placeholder: "全部",
                          },
                          model: {
                            value: _vm.query.guidanceYearRanges,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "guidanceYearRanges", $$v)
                            },
                            expression: "query.guidanceYearRanges",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "1 年以下", value: "under1" },
                          }),
                          _c("el-option", {
                            attrs: { label: "1–3 年", value: "1-3" },
                          }),
                          _c("el-option", {
                            attrs: { label: "4–7 年", value: "4-7" },
                          }),
                          _c("el-option", {
                            attrs: { label: "8–10 年", value: "8-10" },
                          }),
                          _c("el-option", {
                            attrs: { label: "10 年以上", value: "over10" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "居住縣市" } },
                    [
                      _c("el-select", {
                        attrs: {
                          multiple: "",
                          filterable: "",
                          "allow-create": "",
                          "default-first-option": "",
                          "collapse-tags": "",
                          clearable: "",
                          placeholder: "請輸入縣市",
                        },
                        model: {
                          value: _vm.query.residences,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "residences", $$v)
                          },
                          expression: "query.residences",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "協會會員" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "全部" },
                          model: {
                            value: _vm.query.associationMember,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "associationMember", $$v)
                            },
                            expression: "query.associationMember",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "是", value: true },
                          }),
                          _c("el-option", {
                            attrs: { label: "否", value: false },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "可配合日期" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          placeholder: "選擇日期",
                        },
                        model: {
                          value: _vm.query.availableDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "availableDate", $$v)
                          },
                          expression: "query.availableDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序" } },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.query.sort,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "sort", $$v)
                            },
                            expression: "query.sort",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "推薦優先", value: "recommended" },
                          }),
                          _c("el-option", {
                            attrs: { label: "最近更新", value: "updated" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            icon: "el-icon-search",
                            loading: _vm.loading,
                          },
                          on: { click: _vm.search },
                        },
                        [_vm._v(" 查詢 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-refresh",
                            disabled: _vm.loading,
                          },
                          on: { click: _vm.reset },
                        },
                        [_vm._v("重設")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.loadError
        ? _c(
            "el-alert",
            {
              staticClass: "load-alert",
              attrs: {
                type: "error",
                title: _vm.loadError,
                closable: false,
                "show-icon": "",
              },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { slot: "default", size: "mini" },
                  on: { click: _vm.fetchProfiles },
                  slot: "default",
                },
                [_vm._v("重新載入")]
              ),
            ],
            1
          )
        : _vm._e(),
      !_vm.featureDisabled
        ? _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.profiles,
                border: "",
                stripe: "",
                "empty-text": "目前沒有符合條件的領隊或導遊",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "人才", "min-width": "220" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "profile-cell" },
                            [
                              _c("el-avatar", {
                                attrs: {
                                  size: 52,
                                  src: scope.row.avatarUrl || _vm.emptyAvatar,
                                },
                              }),
                              _c("div", [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.displayName(scope.row))),
                                ]),
                                _c("div", { staticClass: "secondary-text" }, [
                                  _vm._v(_vm._s(_vm.roleLabel(scope.row))),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2582986372
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "基本資料", "min-width": "170" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(_vm.basicInfo(scope.row))),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1712764029
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "帶團區域與年資", "min-width": "220" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.listText(
                                  scope.row.guidanceAreas ||
                                    scope.row.guidanceAreaNames
                                )
                              )
                            ),
                          ]),
                          _c("small", { staticClass: "secondary-text" }, [
                            _vm._v(
                              _vm._s(
                                scope.row.guidanceYearsLabel ||
                                  scope.row.guidanceYears ||
                                  "未提供"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2505480578
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "居住地", "min-width": "120" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            _vm._s(
                              scope.row.residence ||
                                scope.row.positionName ||
                                "未提供"
                            )
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2876923686
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "協會", width: "100", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.associationMember
                            ? _c(
                                "el-tag",
                                { attrs: { size: "mini", type: "success" } },
                                [_vm._v("會員")]
                              )
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3598493383
                ),
              }),
              _vm.canManageSettings
                ? _c("el-table-column", {
                    attrs: { label: "推薦", width: "110", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.isRecommended
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { size: "mini", type: "success" },
                                    },
                                    [
                                      _vm._v(
                                        " 順序 " +
                                          _vm._s(scope.row.recommendSort) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _c("span", [_vm._v("-")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2009865513
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: _vm.canManageSettings ? 280 : 180,
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.showProfile(scope.row)
                                },
                              },
                            },
                            [_vm._v("詳情")]
                          ),
                          _vm.canManageSettings
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    "data-testid":
                                      "profile-recommendation-entry",
                                    size: "mini",
                                    type: "warning",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openRecommendation(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(" 推薦 ")]
                              )
                            : _vm._e(),
                          _vm.canUseAgencyCommunication
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openContact(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(" 邀約 ")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  944073951
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.featureDisabled && _vm.total > 0,
            expression: "!featureDisabled && total > 0",
          },
        ],
        attrs: {
          total: _vm.total,
          page: _vm.query.page,
          limit: _vm.query.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.query, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.query, "limit", $event)
          },
          pagination: _vm.fetchProfiles,
        },
      }),
      _vm.canManageSettings
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "領隊導遊專區設定",
                visible: _vm.settingsDialogVisible,
                width: "860px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.settingsDialogVisible = $event
                },
              },
            },
            [
              _c(
                "el-tabs",
                {
                  model: {
                    value: _vm.settingsActiveTab,
                    callback: function ($$v) {
                      _vm.settingsActiveTab = $$v
                    },
                    expression: "settingsActiveTab",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "旅行社開放設定", name: "agencies" } },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: { inline: true },
                          nativeOn: {
                            submit: function ($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "旅行社" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "100",
                                  clearable: "",
                                  placeholder: "名稱或代碼",
                                },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.searchSettings($event)
                                  },
                                },
                                model: {
                                  value: _vm.settingsQuery.keyword,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.settingsQuery,
                                      "keyword",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "settingsQuery.keyword",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-search",
                                    loading: _vm.settingsLoading,
                                  },
                                  on: { click: _vm.searchSettings },
                                },
                                [_vm._v(" 查詢 ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.settingsError
                        ? _c("el-alert", {
                            attrs: {
                              type: "error",
                              title: _vm.settingsError,
                              closable: false,
                              "show-icon": "",
                            },
                          })
                        : _vm._e(),
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.settingsLoading,
                              expression: "settingsLoading",
                            },
                          ],
                          attrs: {
                            data: _vm.agencySettings,
                            border: "",
                            "empty-text": "目前沒有可設定的旅行社",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "agencyName",
                              label: "旅行社",
                              "min-width": "220",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "agencyCode",
                              label: "代碼",
                              "min-width": "150",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "專區入口",
                              width: "130",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-switch", {
                                        attrs: {
                                          value: scope.row.isEnabled,
                                          disabled: Boolean(
                                            _vm.settingsSaving[
                                              scope.row.agencyCode
                                            ]
                                          ),
                                          "active-text": "開放",
                                          "inactive-text": "關閉",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.saveAgencySetting(
                                              scope.row,
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1332770131
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "updatedAt",
                              label: "更新時間",
                              "min-width": "180",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "updatedBy",
                              label: "更新者",
                              "min-width": "130",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("pagination", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.settingsTotal > 0,
                            expression: "settingsTotal > 0",
                          },
                        ],
                        attrs: {
                          total: _vm.settingsTotal,
                          page: _vm.settingsQuery.page,
                          limit: _vm.settingsQuery.pageSize,
                        },
                        on: {
                          "update:page": function ($event) {
                            return _vm.$set(_vm.settingsQuery, "page", $event)
                          },
                          "update:limit": function ($event) {
                            return _vm.$set(
                              _vm.settingsQuery,
                              "pageSize",
                              $event
                            )
                          },
                          pagination: _vm.loadSettings,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "專區輪播", name: "banners" } },
                    [
                      _c("el-alert", {
                        attrs: {
                          type: "info",
                          title:
                            "專區輪播沿用現有廣告管理與版位，圖片、排序及上下架時間請在廣告管理維護。",
                          closable: false,
                          "show-icon": "",
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "banner-toolbar" },
                        [
                          _c("span", [
                            _vm._v(
                              "版位代碼：" +
                                _vm._s(_vm.bannerSlotCode || "尚未設定")
                            ),
                          ]),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: { click: _vm.openAdvertisementManagement },
                            },
                            [_vm._v(" 前往廣告管理 ")]
                          ),
                        ],
                        1
                      ),
                      _vm.bannersError
                        ? _c("el-alert", {
                            attrs: {
                              type: "error",
                              title: _vm.bannersError,
                              closable: false,
                              "show-icon": "",
                            },
                          })
                        : _vm._e(),
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.bannersLoading,
                              expression: "bannersLoading",
                            },
                          ],
                          attrs: {
                            data: _vm.banners,
                            border: "",
                            "empty-text": "目前無輪播資料",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "title",
                              label: "名稱",
                              "min-width": "220",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "sort",
                              label: "排序",
                              width: "80",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "狀態",
                              width: "90",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: scope.row.isEnabled
                                              ? "success"
                                              : "info",
                                            size: "mini",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row.isEnabled
                                                  ? "啟用"
                                                  : "停用"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3061406902
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "startAt",
                              label: "上架時間",
                              "min-width": "170",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "endAt",
                              label: "下架時間",
                              "min-width": "170",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.settingsDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("關閉")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.canManageSettings
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "人才推薦設定",
                visible: _vm.recommendationDialogVisible,
                width: "440px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.recommendationDialogVisible = $event
                },
              },
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px" } },
                [
                  _c("el-form-item", { attrs: { label: "人才" } }, [
                    _vm._v(_vm._s(_vm.displayName(_vm.recommendationTarget))),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "推薦" } },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.recommendationForm.isRecommended,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.recommendationForm,
                              "isRecommended",
                              $$v
                            )
                          },
                          expression: "recommendationForm.isRecommended",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "推薦排序" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, max: 9999, step: 1 },
                        model: {
                          value: _vm.recommendationForm.recommendSort,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.recommendationForm,
                              "recommendSort",
                              $$v
                            )
                          },
                          expression: "recommendationForm.recommendSort",
                        },
                      }),
                      _c("div", { staticClass: "secondary-text" }, [
                        _vm._v("數字越小越優先，預設 99。"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.recommendationDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.recommendationSaving,
                      },
                      on: { click: _vm.saveRecommendation },
                    },
                    [_vm._v(" 儲存 ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "領隊導遊公開履歷",
            visible: _vm.profileDialogVisible,
            width: "720px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.profileDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.profileLoading,
                  expression: "profileLoading",
                },
              ],
            },
            [
              _vm.profileError
                ? _c("el-alert", {
                    attrs: {
                      type: "error",
                      title: _vm.profileError,
                      closable: false,
                      "show-icon": "",
                    },
                  })
                : _vm.selectedProfile
                ? _c(
                    "el-descriptions",
                    { attrs: { column: 1, border: "" } },
                    [
                      _c("el-descriptions-item", { attrs: { label: "姓名" } }, [
                        _vm._v(_vm._s(_vm.displayName(_vm.selectedProfile))),
                      ]),
                      _c("el-descriptions-item", { attrs: { label: "身分" } }, [
                        _vm._v(_vm._s(_vm.roleLabel(_vm.selectedProfile))),
                      ]),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "個人簡介" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.selectedProfile.selfDescription || "未提供"
                            )
                          ),
                        ]
                      ),
                      _c("el-descriptions-item", { attrs: { label: "經歷" } }, [
                        _vm._v(
                          _vm._s(_vm.selectedProfile.experience || "未提供")
                        ),
                      ]),
                      _c("el-descriptions-item", { attrs: { label: "專長" } }, [
                        _vm._v(
                          _vm._s(_vm.listText(_vm.selectedProfile.specialties))
                        ),
                      ]),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "近期帶團" } },
                        [
                          _vm.selectedProfile.recentTravels &&
                          _vm.selectedProfile.recentTravels.length
                            ? _c(
                                "ul",
                                _vm._l(
                                  _vm.selectedProfile.recentTravels,
                                  function (travel) {
                                    return _c(
                                      "li",
                                      { key: travel.id || travel.travelId },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              travel.name || travel.travelName
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            : _c("span", [_vm._v("無可公開資料")]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.profileDialogVisible = false
                    },
                  },
                },
                [_vm._v("關閉")]
              ),
              _vm.selectedProfile && _vm.canUseAgencyCommunication
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.openContact(_vm.selectedProfile)
                        },
                      },
                    },
                    [_vm._v("邀約或傳訊")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm.canUseAgencyCommunication
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "建立邀約或第一則訊息",
                visible: _vm.contactDialogVisible,
                width: "620px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.contactDialogVisible = $event
                },
              },
            },
            [
              _c("el-alert", {
                attrs: {
                  title:
                    "必須選擇屬於目前旅行社的旅行團；系統將由登入身分決定旅行社範圍。",
                  type: "info",
                  closable: false,
                  "show-icon": "",
                },
              }),
              _c(
                "el-form",
                {
                  ref: "contactForm",
                  attrs: {
                    model: _vm.contactForm,
                    rules: _vm.contactRules,
                    "label-width": "110px",
                  },
                },
                [
                  _c("el-form-item", { attrs: { label: "對象" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.contactTarget
                          ? _vm.displayName(_vm.contactTarget)
                          : ""
                      )
                    ),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "聯絡方式", prop: "contactType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.contactForm.contactType,
                            callback: function ($$v) {
                              _vm.$set(_vm.contactForm, "contactType", $$v)
                            },
                            expression: "contactForm.contactType",
                          },
                        },
                        [
                          _c(
                            "el-radio-button",
                            { attrs: { label: "message" } },
                            [_vm._v("傳送訊息")]
                          ),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "invitation" } },
                            [_vm._v("建立邀約")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "旅行團", prop: "travelId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            filterable: "",
                            loading: _vm.travelLoading,
                            placeholder: "請選擇旅行團",
                          },
                          model: {
                            value: _vm.contactForm.travelId,
                            callback: function ($$v) {
                              _vm.$set(_vm.contactForm, "travelId", $$v)
                            },
                            expression: "contactForm.travelId",
                          },
                        },
                        _vm._l(_vm.travels, function (travel) {
                          return _c("el-option", {
                            key: travel.id || travel.travelId,
                            attrs: {
                              label: travel.name || travel.travelName,
                              value: travel.id || travel.travelId,
                            },
                          })
                        }),
                        1
                      ),
                      _vm.travelError
                        ? _c("div", { staticClass: "form-error" }, [
                            _vm._v(_vm._s(_vm.travelError)),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.contactForm.contactType === "invitation"
                    ? [
                        _c(
                          "el-form-item",
                          { attrs: { label: "邀約標題", prop: "title" } },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "120",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.contactForm.title,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.contactForm,
                                    "title",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "contactForm.title",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "工作日期", prop: "workDates" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "value-format": "yyyy-MM-dd",
                                "range-separator": "至",
                                "start-placeholder": "開始日",
                                "end-placeholder": "結束日",
                              },
                              model: {
                                value: _vm.contactForm.workDates,
                                callback: function ($$v) {
                                  _vm.$set(_vm.contactForm, "workDates", $$v)
                                },
                                expression: "contactForm.workDates",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "回覆期限", prop: "expiresAt" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                              },
                              model: {
                                value: _vm.contactForm.expiresAt,
                                callback: function ($$v) {
                                  _vm.$set(_vm.contactForm, "expiresAt", $$v)
                                },
                                expression: "contactForm.expiresAt",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "訊息", prop: "content" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 5,
                          maxlength: "1000",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.contactForm.content,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.contactForm,
                              "content",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "contactForm.content",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.contactDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.contactSubmitting,
                      },
                      on: { click: _vm.submitContact },
                    },
                    [_vm._v("送出")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.canUseAgencyCommunication
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "邀約與聊天歷史",
                visible: _vm.historyDialogVisible,
                width: "900px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.historyDialogVisible = $event
                },
              },
            },
            [
              _vm.historyError
                ? _c("el-alert", {
                    attrs: {
                      type: "error",
                      title: _vm.historyError,
                      closable: false,
                      "show-icon": "",
                    },
                  })
                : _vm._e(),
              _c(
                "el-tabs",
                {
                  model: {
                    value: _vm.activeHistoryTab,
                    callback: function ($$v) {
                      _vm.activeHistoryTab = $$v
                    },
                    expression: "activeHistoryTab",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "聊天紀錄", name: "conversations" } },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.historyLoading,
                              expression: "historyLoading",
                            },
                          ],
                          attrs: {
                            data: _vm.conversations,
                            "empty-text": "尚無聊天歷史",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "travelName",
                              label: "旅行團",
                              "min-width": "180",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "memberName",
                              label: "領隊／導遊",
                              "min-width": "120",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "lastMessagePreview",
                              label: "最後訊息",
                              "min-width": "220",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "unreadCount",
                              label: "未讀",
                              width: "70",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "lastMessageAt",
                              label: "最後聯絡",
                              width: "170",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "90",
                              align: "center",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openConversation(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("開啟")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2535605596
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "邀約紀錄", name: "invitations" } },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.invitationLoading,
                              expression: "invitationLoading",
                            },
                          ],
                          attrs: {
                            data: _vm.invitations,
                            "empty-text": "尚無邀約紀錄",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "travelName",
                              label: "旅行團",
                              "min-width": "170",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "memberName",
                              label: "領隊／導遊",
                              "min-width": "120",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "title",
                              label: "邀約標題",
                              "min-width": "180",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "狀態",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: _vm.invitationStatusType(
                                              scope.row.status
                                            ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.invitationStatusLabel(
                                                  scope.row.status
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1600927974
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "sentAt",
                              label: "送出時間",
                              width: "170",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "90",
                              align: "center",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm.canCancelInvitation(scope.row)
                                        ? _c(
                                            "el-button",
                                            {
                                              staticClass: "danger-action",
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.cancelInvitation(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" 撤回 ")]
                                          )
                                        : _c("span", [_vm._v("-")]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1504498394
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.canUseAgencyCommunication
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "聊天室",
                visible: _vm.chatDialogVisible,
                width: "860px",
                "append-to-body": "",
                "custom-class": "hunter-chat-dialog",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.chatDialogVisible = $event
                },
                closed: _vm.closeConversation,
              },
            },
            [
              _vm.selectedConversation
                ? [
                    _c("div", { staticClass: "hunter-chat-header" }, [
                      _c("span", { staticClass: "hunter-chat-name" }, [
                        _vm._v(
                          _vm._s(
                            _vm.selectedConversation.memberName || "領隊／導遊"
                          )
                        ),
                      ]),
                      _c("span", { staticClass: "hunter-chat-divider" }, [
                        _vm._v("丨"),
                      ]),
                      _c("span", { staticClass: "hunter-chat-travel" }, [
                        _vm._v(
                          _vm._s(
                            _vm.selectedConversation.travelName ||
                              "旅行團名稱未提供"
                          )
                        ),
                      ]),
                    ]),
                    _vm.conversationReadOnly
                      ? _c("el-alert", {
                          attrs: {
                            title:
                              "會員資格已過期或已停權，此對話目前僅可閱讀。",
                            type: "warning",
                            closable: false,
                            "show-icon": "",
                          },
                        })
                      : _vm._e(),
                    _vm.chatError
                      ? _c("el-alert", {
                          staticClass: "load-alert",
                          attrs: {
                            type: "error",
                            title: _vm.chatError,
                            closable: false,
                            "show-icon": "",
                          },
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.chatLoading,
                            expression: "chatLoading",
                          },
                        ],
                        staticClass: "message-list",
                      },
                      [
                        !_vm.chatLoading && _vm.messages.length === 0
                          ? _c("div", { staticClass: "empty-message" }, [
                              _vm._v("尚無訊息"),
                            ])
                          : _vm._e(),
                        _vm._l(_vm.groupedChatMessages, function (item) {
                          return [
                            item.divider
                              ? _c(
                                  "div",
                                  {
                                    key: "date-" + item.key,
                                    staticClass: "hunter-chat-date",
                                  },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: { type: "info", size: "small" },
                                      },
                                      [_vm._v(_vm._s(item.label))]
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    key: item.key,
                                    staticClass: "message-item",
                                    class: {
                                      "message-agency": _vm.isAgencyMessage(
                                        item.message
                                      ),
                                    },
                                  },
                                  [
                                    !_vm.isAgencyMessage(item.message)
                                      ? _c(
                                          "div",
                                          { staticClass: "message-sender" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "sender-avatar" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm
                                                      .messageSenderLabel(
                                                        item.message
                                                      )
                                                      .slice(0, 1)
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "sender-name" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.messageSenderLabel(
                                                      item.message
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c("div", { staticClass: "message-row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "message-content",
                                          class: {
                                            "message-image-body":
                                              _vm.isImageMessage(item.message),
                                          },
                                        },
                                        [
                                          _vm.isImageMessage(item.message)
                                            ? [
                                                _vm.chatImageUrls[
                                                  _vm.chatMediaKey(item.message)
                                                ]
                                                  ? _c("img", {
                                                      staticClass: "chat-image",
                                                      attrs: {
                                                        src: _vm.chatImageUrls[
                                                          _vm.chatMediaKey(
                                                            item.message
                                                          )
                                                        ],
                                                        alt: "聊天圖片",
                                                      },
                                                    })
                                                  : _vm.chatImageLoading[
                                                      _vm.chatMediaKey(
                                                        item.message
                                                      )
                                                    ]
                                                  ? _c("span", [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-loading",
                                                      }),
                                                      _vm._v(" 圖片載入中… "),
                                                    ])
                                                  : _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          type: "text",
                                                          icon: "el-icon-refresh",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.loadProtectedImage(
                                                              item.message
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm
                                                                .chatImageErrors[
                                                                _vm.chatMediaKey(
                                                                  item.message
                                                                )
                                                              ] || "載入圖片"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            : [
                                                _vm._v(
                                                  _vm._s(
                                                    item.message.content ||
                                                      item.message.text ||
                                                      ""
                                                  )
                                                ),
                                              ],
                                        ],
                                        2
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "message-time" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              (
                                                item.message.createdAt ||
                                                item.message.sentAt ||
                                                ""
                                              ).slice(11, 16)
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                          ]
                        }),
                      ],
                      2
                    ),
                    _vm.failedImageFile || _vm.failedChatEnvelope
                      ? _c(
                          "div",
                          { staticClass: "chat-retry-row" },
                          [
                            _vm.failedImageFile
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      disabled:
                                        _vm.chatUploading || _vm.chatSubmitting,
                                    },
                                    on: { click: _vm.retryImageUpload },
                                  },
                                  [_vm._v(" 重試上傳 ")]
                                )
                              : _vm._e(),
                            _vm.failedChatEnvelope
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      disabled:
                                        _vm.chatUploading || _vm.chatSubmitting,
                                    },
                                    on: { click: _vm.retryFailedChatMessage },
                                  },
                                  [_vm._v(" 重試傳送上一則訊息 ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "chat-input-row" },
                      [
                        _c("input", {
                          ref: "chatImageInput",
                          staticClass: "visually-hidden-file",
                          attrs: {
                            type: "file",
                            accept: "image/jpeg,image/png,image/webp",
                            disabled:
                              _vm.conversationReadOnly ||
                              _vm.chatSubmitting ||
                              _vm.chatUploading,
                          },
                          on: { change: _vm.selectChatImage },
                        }),
                        _c(
                          "el-input",
                          {
                            attrs: {
                              placeholder: "輸入文字",
                              maxlength: "1000",
                              disabled:
                                _vm.conversationReadOnly || _vm.chatSubmitting,
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.sendConversationMessage($event)
                              },
                            },
                            model: {
                              value: _vm.chatInput,
                              callback: function ($$v) {
                                _vm.chatInput =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "chatInput",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  slot: "prepend",
                                  icon: "el-icon-picture-outline",
                                  loading: _vm.chatUploading,
                                  disabled:
                                    _vm.conversationReadOnly ||
                                    _vm.chatSubmitting ||
                                    _vm.chatUploading,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.$refs.chatImageInput &&
                                      _vm.$refs.chatImageInput.click()
                                  },
                                },
                                slot: "prepend",
                              },
                              [_vm._v(" 上傳 ")]
                            ),
                            _c("el-button", {
                              attrs: {
                                slot: "append",
                                icon: "el-icon-s-promotion",
                                loading: _vm.chatSubmitting,
                                disabled:
                                  _vm.conversationReadOnly ||
                                  _vm.chatSubmitting ||
                                  !_vm.chatInput,
                              },
                              on: { click: _vm.sendConversationMessage },
                              slot: "append",
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h2", [_vm._v("尋找領隊與導遊")]),
      _c("p", [_vm._v("僅列出已付費、尚在有效期且開放履歷的會員。")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }